import React from 'react';
import { Navbar } from './Navbar';
import Paper from '@mui/material/Paper';
import { Header } from './Header';
import { SearchBar } from './SearchBar';

interface CommonLayoutProps {
    children: React.ReactNode;
    onLogout: () => void;
    user: string;
    userRole: string;
    userAuthenticated : string;
}

const CommonLayout: React.FC<CommonLayoutProps> = ({ children, onLogout, user, userRole, userAuthenticated }) => {
    const handleTextCallback = (text: string) => {
        console.log(text);
    }

    return (
        <>
            <div className='left-panel'>
                <Header userAuthenticated={userAuthenticated} user={user} userRole={userRole} onLogout={onLogout}/>
                <div className='display-page'>
                    <Navbar userRole={userRole}onLogout={onLogout} />
                    <Paper elevation={3} className="custom-paper">
                        {children}
                    </Paper>
                </div>
            </div>
            <div className="right-panel">
                <SearchBar callback={handleTextCallback} text={""} id="generic-search"></SearchBar>
            </div>
        </>
    );
};

export default CommonLayout;
